import React, { useEffect } from "react";
import CompleteTheForm from "../../assets/svg/CompleteTheForm.svg";
import ReviewAndSubmit from "../../assets/svg/ReviewAndSubmit.svg";
import SignContract from "../../assets/svg/SignContract.svg";

import { useLocation, useNavigate } from "react-router-dom";
import styles from "./CG_WelcomScreen.module.css";
import Header from "../Header/Header";
import BenefitCard from "../GetQualified/FinancialPreQualification/BenefitCard";
import config from "../../config";

const benefits = [
    {
        iconSrc: CompleteTheForm,
        title: "Complete the Form",
        description: "Follow the prompts to fill out each section of your contract.",
    },
    {
        iconSrc: ReviewAndSubmit,
        title: "Review and Submit",
        description: "Double-check all information for accuracy. Once satisfied, submit the form.",
    },
    {
        iconSrc: SignContract,
        title: "Sign the E-Contract",
        description: "Once complete, easily sign your contract electronically to finalize the process.",
    },
];

export default function CG_WelcomScreen() {
    const location = useLocation();
    const document = location.state;
    const navigate = useNavigate();
    useEffect(() => {
        window.document.title = `Contract Generation | ${config.get("COMPANY_NAME")}`;
    }, []);
    return (
        <div className={`${styles.container}  tw-bg-background_color`}>
            <main className={`${styles.mainContent} tw-overflow-y-auto`}>
                <Header title="Contract Generation" />
                <div></div>
                <section className={`${styles.contentWrapper} tw-px-3 tw-mt-10`}>
                    <div className={`${styles.titleSection}`}>
                        <h2 className={styles.mainTitle}>Welcome to the Contract Generation Tool</h2>
                        <p className={`${styles.subtitle} tw-max-w-[965px]  tw-mt-2`}>
                            Welcome to our state-of-the-art contract generation tool, designed to make creating real estate contracts simple and
                            efficient. This tool guides you through each step, ensuring accuracy and ease of use.
                        </p>
                    </div>
                    <div className={`${styles.benefitsContainer} max-lg:tw-flex-nowrap`}>
                        {benefits.map((benefit, index) => (
                            <BenefitCard key={index} {...benefit} />
                        ))}
                    </div>
                    <p className="tw-mt-5">Feel free to adjust any details to better match your specific requirements.</p>
                    <div className={styles.ctaWrapper}>
                        <button
                            onClick={() =>
                                navigate("/contract-generation/questions", {
                                    state: { document },
                                })
                            }
                            className={`${styles.ctaButton} tw-bg-primary hover:tw-bg-primary_hover`}
                        >
                            <div className={styles.ctaContent}>
                                <span className={`${styles.ctaText} tw-font-normal `}>Get started</span>
                            </div>
                        </button>
                    </div>
                </section>
                <footer className={styles.footerWrapper}>
                    <p className={styles.footerText}>Your information is safe and secure with us.</p>
                    <a onClick={() => navigate("/privacy-policy")} className={styles.footerLink}>
                        Learn more about our privacy policy
                    </a>
                </footer>
            </main>
        </div>
    );
    //     return (
    //         <div className="tw-p-10 tw-pt-[70px] tw-flex tw-flex-col tw-items-center tw-h-screen">
    //             <Header title={"Contract Generation "} />
    //             <div className="tw-w-full xl:tw-w-[80%] tw-text-center">
    //                 <h1 className="tw-text-secondary tw-text-[33px] tw-font-[700]">Welcome to the Contract Generation Tool</h1>
    //                 <p className="tw-text-center tw-text-[18px] tw-text-[#344054]">
    //                     Welcome to our state-of-the-art contract generation tool, designed to make creating real estate contracts simple and efficient.
    //                     This tool guides you through each step, ensuring accuracy and ease of use.
    //                 </p>
    //             </div>
    //             <div className="tw-flex tw-flex-col xl:tw-flex-row tw-gap-5 xl:tw-gap-0 tw-justify-between tw-mt-10">
    //                 {array.map((item, index) => (
    //                     <div
    //                         key={index}
    //                         className="tw-bg-[#fff5f0] tw-w-[100%] xl:tw-w-[28%] tw-text-center tw-gap-3 tw-py-7 tw-border tw-text-[#001659] tw-flex tw-flex-col tw-items-center tw-border-dashed tw-border-secondary tw-rounded-md"
    //                     >
    //                         <img src={item.image} className="tw-h-[70px] tw-w-[70px] tw-object-contain" alt="sign" />
    //                         <h3 className="tw-text-[20px] tw-font-[600] ">{item.title}</h3>
    //                         <p>{item.description}</p>
    //                     </div>
    //                 ))}
    //             </div>
    //             <p className="tw-text-[18px] tw-text-[#344054] tw-text-center tw-mt-5">
    //                 Feel free to adjust any details to better match your specific requirements.
    //             </p>
    //             <div className="tw-flex tw-justify-center">
    //                 <button
    //                     onClick={() =>
    //                         navigate("/contract-generation/questions", {
    //                             state: { document },
    //                         })
    //                     }
    //                     className="tw-bg-[#001659] tw-text-white tw-font-[800] tw-text-[24px] tw-rounded-md tw-py-1 tw-mt-4 tw-px-5"
    //                 >
    //                     Start
    //                 </button>
    //             </div>
    //         </div>
    //     );
}
